import { formatDate } from '@angular/common';
import { Component, Inject, LOCALE_ID, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/services/api.service';
import { TimeTrackerService } from 'src/app/services/time-tracker.service';
import { NotificationService } from '../../../services/notification.service';
import { SharedService } from '../../shared/shared.service';

@Component({
  selector: 'app-mytime-tracker',
  templateUrl: './mytime-tracker.component.html',
  styleUrls: ['./mytime-tracker.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})

export class MytimeTrackerComponent implements OnInit, OnDestroy {

  @ViewChild('manualtimeentry') manualtimeentry: TemplateRef<any>;
  @ViewChild('deletetimeentry') deletetimeentry: TemplateRef<any>;
  displayedColumns: string[] = ['checkbox', 'clientname', 'engagementid', 'category', 'type', 'billable', /*'starttime', 'endtime',*/ 'duration', 'notes', 'actions'];
  loggedInUserData: any;
  userLoginId: any;
  ttNotifications: any;
  timeEntries: any = [];
  childTimeEntries: any = [];
  engagementID: any;
  clients: any = [];
  engagements: any = [];
  entries: any = [];
  categories: any = [];
  manualForm: UntypedFormGroup;
  fullName: string;
  roleName: string;
  timeData: any = [];
  duration: string = '00h:00m:00s';
  isEntryExpanded: boolean = true;
  isDisableSubmitBtn = true;
  allEntriesCheked = false;
  filterClientData: any = [];
  filterEngs: any = [];
  filterAllData: any[];
  filterCategories: any = [];
  selectedEngItems: any;
  selectedCategoryItems: any;
  selectedClientItems: any;
  filteredEntriesData = [];
  filterTimeType: any = [];
  selectedTimeTypeItems: any;
  billType: any = [];
  selectedBillTypeItems: { entryName: string; timeTrackingEntryId: number; checked: boolean; }[];
  singleEntryData: any;
  deleteObj: { engagementsTimeTrackingId: any; loginId: any; };
  showNoRecords = false;
  isActiveDeleteBtn = false;
  isDisableDeleteBtn = true;
  editTitle: string;
  isEdit = false;
  allEntriesChecked = false;
  allTodayEntriesChecked = false;
  deleteArray = [];
  deleteTitle: string;
  deleteType: string;
  maxDate: Date;
  typesFilter = [];

  constructor(private dialog: MatDialog, private fb: UntypedFormBuilder, private trackerService: TimeTrackerService,
              @Inject(LOCALE_ID) private locale: string, private toaster: ToastrService,
              private sharedService: SharedService, private apiService: ApiService, private notifService: NotificationService) { }

  ngOnInit() {
    this.engagementID = JSON.parse((localStorage.getItem('engagementID')));
    this.userLoginId = this.sharedService.getUserData('field', 'useracctid');
    this.fullName = this.sharedService.getUserData('field', 'fullName');
    this.roleName = this.sharedService.getUserData('field', 'roleName');
    this.maxDate = new Date();
    this.loadLsForm();
    this.getTimeEntries();
    this.getEntryTypes();
    this.getClients();
    this.getScheduleTime();
  }

  getFilterData() {
    this.getFilterClients();
    this.getFilterEngs();
    this.getFilterCategories();
    this.getFilterTimeType();
  }

  loadLsForm() {
    this.manualForm = this.fb.group({
      'createdDate': [new Date(), Validators.required],
      'entryType': ['', Validators.required],
      'clientName': ['', Validators.required],
      'engagementId': ['', Validators.required],
      'category': ['', Validators.required],
      'startTime': ['', Validators.required],
      'endTime': ['', Validators.required],
      'notes': ['', Validators.required]
    });
  }

  getTimeEntries() {
    let engagementId = 0;
    this.trackerService.getTimeEntries(engagementId).subscribe(res => {
      if (res) {
        let data = JSON.parse(res);
        localStorage.setItem('viewTimeEntries', JSON.stringify(data));
        this.timeEntries = data;
        this.getFilterData();
        this.getTypes();
        this.timeEntries.map(e => {
          e.isExpaned = true;
        });
        this.filterViewTimeEntries();
      }

    });
  }

  getTypes() {
    this.billType = [];
    this.timeEntries.forEach(e => {
      if (e.timeEntries) {
        e.timeEntries.map(x => x.entryName)
          .filter((v, i, a) => a.indexOf(v) === i)
          .map((value) => {
            this.billType.push({entryName: value, checked: false});
          });
      }
    });
    this.typesFilter = this.billType.filter(function (a) {
      return !this[a.entryName] && (this[a.entryName] = true);
    }, Object.create(null));
  }

  bindMatGrid(data) {
    //this.childTimeEntries = new MatTableDataSource(data);
    return new MatTableDataSource(data);
  }

  trackByEntries(index) {
    return index;
  }

  openActivetimeEntryDialog(element) {
    this.resetForm();
    this.singleEntryData = element;
    this.isEdit = true;
    this.duration = element.duration;
    this.getEngagements({'clientFirmId': element.clientFirmId});
    this.getCategories({'timeTrackingEntryId': element.timeTrackingEntryId});
    if (element.timeTrackingTypeId == 1) {
      this.editTitle = 'Edit Active Time Entry';
      this.updateEditForm(element, 'Active');
    } else {
      this.editTitle = 'Edit Manual Time Entry';
      this.updateEditForm(element, 'Manual');
    }
    if (element.isIdleTime == 1) {
      this.editTitle = 'Edit Idle Time Entry';
      this.updateEditForm(element, 'Idle');
    }
    this.dialog.open(this.manualtimeentry, {disableClose: true});
  }

  resetForm() {
    this.manualForm.reset();
  }

  openManualtimeEntryDialog(element?) {
    this.editTitle = 'Add Manual Time Entry';
    this.isEdit = false;
    this.dialog.open(this.manualtimeentry, {disableClose: true});
    this.enableInputs('createdDate');
    this.setValue('createdDate', new Date());
    this.enableInputs('entryType');
    this.disableInputs('engagementId');
    this.disableInputs('category');
    this.disableInputs('clientName');
    this.setValue('endTime');
    this.enableInputs('startTime');
    this.disableInputs('endTime');
  }

  updateEditForm(obj, type) {

    if (type === 'Active' || type === 'Idle') {
      this.disableInputs('createdDate');
      this.disableInputs('entryType');
      this.disableInputs('engagementId');
      this.disableInputs('category');
      this.disableInputs('clientName');
      this.disableInputs('startTime');
      this.disableInputs('endTime');
    } else {
      if (obj.timeTrackingEntryId == 2) {
        this.setValue('clientName');
        this.setValue('engagementId');
        this.enableInputs('createdDate');
        this.enableInputs('entryType');
        this.enableInputs('category');
        this.enableInputs('startTime');
        this.enableInputs('endTime');
        this.disableInputs('clientName');
        this.disableInputs('engagementId');
      } else {
        this.enableInputs('createdDate');
        this.enableInputs('entryType');
        this.enableInputs('engagementId');
        this.enableInputs('category');
        this.enableInputs('clientName');
        this.enableInputs('startTime');
        this.enableInputs('endTime');
      }
    }
    this.manualForm.patchValue({
      'createdDate': moment(obj.date).toDate(),
      'entryType': obj.timeTrackingEntryId.toString(),
      'clientName': obj.clientFirmId.toString(),
      'category': obj.timeCategoryId.toString(),
      'engagementId': obj.engagementsId.toString(),
      'startTime': obj.startTime,
      'endTime': obj.endTime,
      'notes': obj.notes
    });
  }

  openDeletetimeEntryDialog(type: 'multi' | 'single', element?) {
    this.deleteArray = [];
    this.deleteType = type;
    if (type === 'multi' && this.isDisableDeleteBtn) {
      return;
    }
    if (type === 'single') {
      this.deleteTitle = 'Delete manual time entry?';
      this.singleEntryData = element;
      this.deleteObj = {'engagementsTimeTrackingId': element.engagementsTimeTrackingId, 'loginId': this.userLoginId};
    } else {
      this.deleteTitle = 'Delete manual time entries?';
      this.timeEntries.forEach(e => {
        e.timeEntries.forEach(ce => {
          if (ce.checked) {
            let obj = {'engagementsTimeTrackingId': ce.engagementsTimeTrackingId, 'loginId': this.userLoginId};
            this.deleteArray.push(obj);
          }
        });
      });
    }
    this.dialog.open(this.deletetimeentry, {disableClose: true});
  }

  deleteTimeEntry(type: 'multi' | 'single') {
    const deleteObj = {
      'delete': type === 'multi' ? this.deleteArray : [this.deleteObj]
    };
    const relativePath = 'delete-time-entry';
    this.trackerService.saveApiData(relativePath, deleteObj).subscribe(res => {
      if (res) {
        this.disableState();
        this.clearFilters('all');
        this.getTimeEntries();
        this.toaster.success('Time entry deleted successfully');
      }
    }, error => {
      this.toaster.error(error.error);
    });
  }

  getEntryTypes() {
    const relativePath = 'entry-type';
    this.trackerService.getApiData(relativePath).subscribe(res => {
      if (res) {
        let data = JSON.parse(res);
        this.entries = data;
      }
    }, error => {
      console.error(error.error);
    });
  }

  getClients() {
    this.trackerService.getApiData('client-name').subscribe(res => {
      if (res) {
        let data = JSON.parse(res);
        this.clients = data;
      }
    }, error => {
      console.error(error.error);
    });
  }

  getEngagements(data, setNull?) {
    let clientFirmId = data.clientFirmId;
    const relativePath = +clientFirmId + '/engagement-name';
    this.trackerService.getApiData(relativePath).subscribe(res => {
      if (res) {
        let data = JSON.parse(res);
        this.engagements = data;
        if (setNull) {
          this.setValue('engagementId');
        }
      }
    }, error => {
      console.error(error.error);
    });
  }

  getCategories(data, setNull?) {
    let entryId = data.timeTrackingEntryId;
    const relativePath = +entryId + '/category';
    this.trackerService.getApiData(relativePath).subscribe(res => {
      if (res) {
        let data = JSON.parse(res);
        this.categories = data;
        if (setNull) {
          this.setValue('category');
          this.setValue('clientName');
          this.setValue('engagementId');
        }
      }
    }, error => {
      console.error(error.error);
    });
  }

  getScheduleTime() {
    this.trackerService.getScheduleTime().subscribe({
      next: res => {
        let result: any = [];
        if (res?.status === 200) {
          result = JSON.parse(res?.data);
          this.timeData = result;
        }
      }, error: e => {
        console.error(e.error);
      }
    });
  }

  enableDisableDropdown(data, from: 'entryType' | 'startTime') {
    if (from === 'entryType') {
      this.enableInputs('category');
      if (data.timeTrackingEntryId == 1) {
        this.enableInputs('engagementId');
        this.enableInputs('clientName');
      } else {
        this.disableInputs('engagementId');
        this.disableInputs('clientName');
      }
    } else if (from === 'startTime') {
      this.enableInputs('endTime');
      this.setValue('endTime');
      this.duration = '00h:00m:00s';
    }
  }

  disableInputs(fieldName) {
    this.manualForm.controls[fieldName].disable();
  }

  enableInputs(fieldName) {
    if (this.manualForm.controls[fieldName].disabled) {
      this.manualForm.controls[fieldName].enable();
    }
  }

  setValue(fieldName, value?) {
    this.manualForm.controls[fieldName].setValue(value ? value : null);
  }

  getValue(fieldName) {
    return this.manualForm.controls[fieldName].value;
  }

  timeDiffCalc() {
    let startTime, endTime, minute, hour;
    startTime = this.getValue('startTime');
    endTime = this.getValue('endTime');
    startTime = new Date('01/01/2007 ' + startTime);
    endTime = new Date('01/01/2007 ' + endTime);
    const diffInMs = Date.parse(endTime) - Date.parse(startTime);
    const diffInHours = diffInMs / 1000 / 60 / 60;
    if (diffInHours < 0) {
      this.toaster.error('Endtime must be greaterthan start time');
      this.setValue('endTime');
      this.duration = '00h:00m:00s';
      return;
    }
    let diffInMilliSeconds = Math.abs(endTime - startTime) / 1000;

    // calculate hours
    let hours = Math.floor(diffInMilliSeconds / 3600) % 24;
    diffInMilliSeconds -= hours * 3600;

    // calculate minutes
    const minutes = Math.floor(diffInMilliSeconds / 60) % 60;
    diffInMilliSeconds -= minutes * 60;

    hour = hours.toString();
    minute = minutes.toString();
    hour = hour && hour.length == 1 ? '0' + hour : hour;
    minute = minute && minute.length == 1 ? '0' + minute : minute;
    this.duration = hour + 'h:' + minute + 'm:' + '00s';
  }

  saveManualTime() {
    let obj;
    obj = this.manualForm.value;
    const data = {
      'engagementsId': obj.engagementId ? obj.engagementId : 0,
      'submoduleId': 0,
      'teamUserAccountId': this.userLoginId,
      'timeTrackingEntryId': obj.entryType,
      'timeTrackingTypeId': 2,
      'timeCategoryId': obj.category,
      'isIdleTime': 0,
      'date': formatDate(obj.createdDate, 'yyyy-MM-dd', this.locale),
      'startTime': obj.startTime,
      'endTime': obj.endTime,
      'automaticStartTime': '',
      'duration': this.duration,
      'timeZone': Intl.DateTimeFormat().resolvedOptions().timeZone,
      'notes': obj.notes,
      'loginId': this.userLoginId
    };
    const relativePath = 'save-eng-time-entry';
    this.trackerService.saveApiData(relativePath, data).subscribe(res => {
      if (res) {
        this.resetForm();
        this.disableState();
        this.getTimeEntries();
        this.toaster.success('The activity has been added to your time tracker');
        const engagementId = obj.engagementId ? obj.engagementId : '';
        this.sendNotification(engagementId);
        this.getNotificationStatus();
      }
    }, error => {
      this.toaster.error(error.error);
    });
  }

  sendNotification(engagementId: any) {
    this.notifService.getNotificationStatus().subscribe({
      next: res => {
        let result: any = [];
        if (res?.status === 200) {
          result = JSON.parse(res?.data);
          this.ttNotifications = result.timetrackingnotificatinons;
          const startTrackerObject = {'loginId': this.userLoginId, 'engagementsId': engagementId};
          if (this.ttNotifications[0].childs[4].isnotify) {
            this.trackerService.notifyManualTime(startTrackerObject).subscribe({
              next: res => {
                if (res == 'Success') {
                  localStorage.setItem('sendManualNotify', 'true');
                }
              }
            });
          }
        } 
      }
    });
  }

  getNotificationStatus() {
    this.notifService.getNotificationStatus().subscribe({
      next: res => {
        let result: any = [];
        if (res?.status === 200) {
          result = JSON.parse(res?.data);
          this.ttNotifications = result.timetrackingnotificatinons;
        }
      }
    });
  }

  submitTime() {
    let timeEntry = [];
    this.timeEntries.forEach(e => {
      e.timeEntries.forEach(element => {
        timeEntry.push(element);
      });
    });
    const updateArray = [];
    timeEntry.filter(e => e.checked).forEach(e => {
      const data = {
        'engagementsId': e.engagementsId,
        'engagementsTimeTrackingId': e.engagementsTimeTrackingId,
        'loginId': this.userLoginId,
        'timeTrackingTypeId': e.timeTrackingTypeId,
        'date': e.date,
        'submoduleUuid': e.submoduleUuid != null ? e.submoduleUuid : '',
        'submoduleId': e.submoduleId,
        'isIdleTime': e.isIdleTime,
        'teamUserAccountId': e.teamUserAccountId
      };
      updateArray.push(data);
    });
    const allData = {
      'update': updateArray
    };

    this.trackerService.submitTimeEntry(allData).subscribe(res => {
      if (res) {
        this.getTimeEntries();
        this.toaster.success('Congratulations! All time entries have been submitted!');
      }
    }, error => {
      this.toaster.error(error.error);
    });
  }

  submitSingleEntry(e) {
    const updateArray = [];
    const data = {
      'engagementsId': e.engagementsId,
      'engagementsTimeTrackingId': e.engagementsTimeTrackingId,
      'loginId': this.userLoginId,
      'timeTrackingTypeId': e.timeTrackingTypeId,
      'date': e.date,
      'submoduleUuid': e.submoduleUuid != null ? e.submoduleUuid : '',
      'submoduleId': e.submoduleId,
      'isIdleTime': e.isIdleTime,
      'teamUserAccountId': e.teamUserAccountId
    };
    updateArray.push(data);
    const allData = {
      'update': updateArray
    };

    this.trackerService.submitTimeEntry(allData).subscribe(res => {
      if (res) {
        this.getTimeEntries();
        this.toaster.success('Time entry has been submitted to the time summary.');
      }
    }, error => {
      this.toaster.error(error.error);
    });
  }

  togglePannels(type: 'C' | 'E') {
    this.timeEntries.forEach(e => {
      if (type == 'C') {
        this.isEntryExpanded = false;
        e.isExpanded = false;
      } else {
        this.isEntryExpanded = true;
        e.isExpanded = true;
      }
    });
  }

  singleCheck(type: 'parent' | 'child', childElements, subChildElement?) {
    let totalDataCount, childTotalDataCount, parentCheckedCount, childCheckedCount, deleteArray = [];
    totalDataCount = this.timeEntries.filter(e => e.timeEntries.length).length;
    childTotalDataCount = childElements.timeEntries.length;
    if (type === 'parent') {
      if (childElements.parentChecked == false) {
        childElements.timeEntries.forEach(cele => {
          cele.checked = false;
        });
      } else {

        childElements.timeEntries.forEach(cele => {
          cele.checked = true;
        });
      }
    }
    this.timeEntries.filter(el => {
      el.timeEntries.filter(ele => {
        (ele.checked) ? deleteArray.push(ele) : '';
      });
      //childCheckedCount.length > 0 ? deleteArray.push(childCheckedCount) : '';
    });
    childCheckedCount = childElements.timeEntries.filter(ele => ele.checked).length;
    if (type === 'child') {
      if (childTotalDataCount == childCheckedCount) {
        childElements.parentChecked = true;
      } else {
        childElements.parentChecked = false;
      }
    }
    parentCheckedCount = this.timeEntries.filter(ele => ele.parentChecked).length;
    if (childCheckedCount > 1 || (parentCheckedCount > 0 && deleteArray.length > 1)) {
      this.isDisableSubmitBtn = false;
    } else {
      this.isDisableSubmitBtn = true;
    }
    if (totalDataCount == parentCheckedCount) {
      this.allEntriesCheked = true;
    } else {
      this.allEntriesCheked = false;
    }

    //const sum = deleteArray.reduce((total, currentValue) => total + currentValue,0);
    const sum = deleteArray.filter(ele => ele.timeTrackingTypeId == 2).length;
    if (sum > 1 && deleteArray.length == sum) {
      this.isDisableDeleteBtn = false;
    } else {
      this.isDisableDeleteBtn = true;
    }
  }

  multiCheck() {
    let deleteArray = [];
    if (this.allEntriesCheked) {
      this.timeEntries.forEach(ele => {
        ele.parentChecked = true;
        this.isDisableSubmitBtn = false;
        ele.timeEntries.forEach(x => {
          x.checked = true;
          if (ele.timeEntries.length) {
            deleteArray.push(x);
          }
        });
      });
    } else {
      this.timeEntries.forEach(ele => {
        ele.parentChecked = false;
        this.isDisableSubmitBtn = true;
        ele.timeEntries.forEach(ele => {
          ele.checked = false;
        });
      });
    }
    //const sum = deleteArray.reduce((total, currentValue) => total + currentValue,0);
    const sum = deleteArray.filter(ele => ele.timeTrackingTypeId == 2).length;
    if (sum > 1 && deleteArray.length == sum) {
      this.isDisableDeleteBtn = false;
    } else {
      this.isDisableDeleteBtn = true;
    }
  }

  //filters
  getFilterClients() {
    const relativePath = 0 + '/client-time-summary';
    this.trackerService.getApiData(relativePath).subscribe(res => {
      if (res) {
        let data = JSON.parse(res);
        this.filterClientData = data;
      }
    }, error => {
      console.error(error.error);
    });
  }

  getFilterEngs() {
    const relativePath = 0 + '/eng-time-summary';
    this.trackerService.getApiData(relativePath).subscribe(res => {
      if (res) {
        let data = JSON.parse(res);
        this.filterEngs = data;
      }
    }, error => {
      console.error(error.error);
    });
  }

  getFilterCategories() {
    const relativePath = 0 + '/category-time-summary';
    this.trackerService.getApiData(relativePath).subscribe(res => {
      if (res) {
        let data = JSON.parse(res);
        this.filterCategories = data;
      }
    }, error => {
      console.error(error.error);
    });
  }

  getFilterTimeType() {
    const relativePath = 0 + '/type-time-summary';
    this.trackerService.getApiData(relativePath).subscribe(res => {
      if (res) {
        let data = JSON.parse(res);
        this.filterTimeType = data;
      }
    }, error => {
      console.error(error.error);
    });
  }

  disableState() {
    this.isDisableSubmitBtn = true;
    this.isDisableDeleteBtn = true;
    this.allEntriesCheked = false;
  }

  filterViewTimeEntries() {
    this.disableState();
    this.timeEntries.forEach(e => {
      e.parentChecked = false;
      e.timeEntries.forEach(ele => ele.checked = false);
    });
    let copyData = JSON.parse(localStorage.getItem('viewTimeEntries'));
    let selectedEngs = this.filterEngs.filter(y => y.checked == true);
    let selectedCategories = this.filterCategories.filter(y => y.checked == true);
    let selectedClients = this.filterClientData.filter(y => y.checked == true);
    let selectedTimeType = this.filterTimeType.filter(y => y.checked == true);
    let selectedBillType = this.typesFilter.filter(y => y.checked == true);

    this.selectedEngItems = selectedEngs;
    this.selectedCategoryItems = selectedCategories;
    this.selectedClientItems = selectedClients;
    this.selectedTimeTypeItems = selectedTimeType;
    this.selectedBillTypeItems = selectedBillType;

    let engagement = this.filterColumn(selectedEngs, 'engagementsId');
    let category = this.filterColumn(selectedCategories, 'submoduleName');
    let client = this.filterColumn(selectedClients, 'clientName');
    let timeType = this.filterColumn(selectedTimeType, 'timeTrackingTypeId');
    let typesFilter = this.filterColumn(selectedBillType, 'entryName');
    if (engagement.length == 0 && category.length == 0 && client.length == 0 && timeType.length == 0 && typesFilter.length == 0) {
      if (this.filteredEntriesData && this.filteredEntriesData.length > 0) {
        this.filteredEntriesData = [];
      }
      this.timeEntries = copyData;
    } else {
      let results1 = this.filterLists(engagement, category, 'submoduleName');
      let results2 = this.filterLists(results1, client, 'clientName');
      let results3 = this.filterLists(results2, timeType, 'timeTrackingTypeId');
      let results4 = this.filterLists(results3, typesFilter, 'timeTrackingEntryId');
      this.filteredEntriesData = results4;
      let noRecordsArray = [];
      this.timeEntries.forEach(element => {
        let filteredArray = [];
        this.filteredEntriesData.forEach(ele => element.day == ele.date ? filteredArray.push(ele) : '');
        noRecordsArray.push(filteredArray.length);
        element.timeEntries = filteredArray;
      });
      const sum = noRecordsArray.reduce((total, currentValue) => total + currentValue, 0);
      if (sum == 0) {
        this.showNoRecords = true;
        this.disableState();
      } else {
        this.showNoRecords = false;
      }
    }
  }

  filterLists(list1, list2, property1) {
    let filteredList = [];
    let tempList = [];
    if ((list1 && list2) && (list1.length > 0 && list2.length > 0)) {
      list1.forEach(item => {
        tempList = list2.filter((x, i) => {
          return x[property1] == item[property1];
        });
        if (tempList.length > 0) {
          filteredList.push(item);
        }
      });
    } else {
      if (list1.length == 0 && list2.length > 0) {
        filteredList = list2;
      }
      if (list2.length == 0 && list1.length > 0) {
        filteredList = list1;
      }
    }

    return filteredList;

  }

  filterColumn(list, property) {
    let filteredList = [];
    let copyData = JSON.parse(localStorage.getItem('viewTimeEntries'));
    this.filterAllData = [];
    let engCheckCount = list.filter(e => e.checked == true).length;
    list.map(f => {
      if (f.checked) {
        if (engCheckCount > 0) {
          copyData.forEach(e => {
            e.timeEntries.filter(ce => f[property] == ce[property] ? filteredList.push(ce) : '');
          });
        }
      }
    });
    return filteredList;
  }

  clearFilters(type: 'type' | 'client' | 'cat' | 'eng' | 'btype' | 'all') {
    if (type === 'type') {
      this.filterTimeType.forEach(x => {
        if (x.checked == true) {
          x.checked = false;
        }
      });
    }
    if (type === 'client') {
      this.filterClientData.forEach(x => {
        if (x.checked == true) {
          x.checked = false;
        }
      });
    }
    if (type === 'cat') {
      this.filterCategories.forEach(x => {
        if (x.checked == true) {
          x.checked = false;
        }
      });
    }
    if (type === 'eng') {
      this.filterEngs.forEach(x => {
        if (x.checked == true) {
          x.checked = false;
        }
      });
    }
    if (type === 'btype') {
      this.typesFilter.forEach(x => {
        if (x.checked == true) {
          x.checked = false;
        }
      });
    }
    if (type === 'all') {
      this.filterTimeType.forEach(x => {
        if (x.checked == true) {
          x.checked = false;
        }
      });
      this.filterClientData.forEach(x => {
        if (x.checked == true) {
          x.checked = false;
        }
      });
      this.filterCategories.forEach(x => {
        if (x.checked == true) {
          x.checked = false;
        }
      });
      this.filterEngs.forEach(x => {
        if (x.checked == true) {
          x.checked = false;
        }
      });
      this.typesFilter.forEach(x => {
        if (x.checked == true) {
          x.checked = false;
        }
      });
    }
    this.filterViewTimeEntries();
  }

  updateTimeEntry() {
    let obj, element, data;
    element = this.singleEntryData;
    obj = this.manualForm.value;
    data = {
      'teamUserAccountId': this.userLoginId,
      'timeTrackingTypeId': element.timeTrackingTypeId,
      'engagementsTimeTrackingId': element.engagementsTimeTrackingId,
      'isIdleTime': element.isIdleTime,
      'timeZone': Intl.DateTimeFormat().resolvedOptions().timeZone,
      'notes': obj.notes,
      'loginId': this.userLoginId,
      'submoduleUuid': element.submoduleUuid
    };
    if (element.timeTrackingTypeId == 1 || element.isIdleTime == 1) {
      data['engagementsId'] = element.engagementsId;
      data['date'] = element.date;
      data['startTime'] = element.startTime;
      data['endTime'] = element.endTime;
      data['duration'] = element.duration;
      data['submoduleId'] = element.submoduleId;
      data['timeTrackingEntryId'] = element.timeTrackingEntryId;
      data['timeCategoryId'] = element.timeCategoryId;
    } else {
      data['engagementsId'] = obj.engagementId ? obj.engagementId : 0;
      data['date'] = formatDate(obj.createdDate, 'yyyy-MM-dd', this.locale);
      data['startTime'] = obj.startTime;
      data['endTime'] = obj.endTime;
      data['duration'] = this.duration;
      data['submoduleId'] = 0;
      data['timeTrackingEntryId'] = obj.entryType;
      data['timeCategoryId'] = obj.category;
    }
    const relativePath = 'update-time-entry';
    this.trackerService.saveApiData(relativePath, data).subscribe(res => {
      if (res) {
        this.resetForm();
        this.disableState();
        this.getTimeEntries();
        this.toaster.success('Time entry updated successfully');
      }
    }, error => {
      this.toaster.error(error.error);
    });
  }

  ngOnDestroy() {

  }

  checkDates(value) {
    this.manualForm.controls['createdDate'].setValue(value);
  }
}
